import { DashboardLayout } from "layouts/dashboard.layout";
import { AssociateTableTable } from "./components/table.component";
import AssociateReportsInfo from "./components/info.component";

export function AssociateReportsPage() {
  return (
    <DashboardLayout>
      <AssociateReportsInfo />
      <AssociateTableTable />
    </DashboardLayout>
  );
}
